var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConnectorArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 16,
    viewBox: "0 0 31 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "down-arrow-a",
    d: "M15.1318932,21.9968659 C15.2899227,22.1541947 15.2899227,22.4052408 15.1285441,22.5659038 L8.03431944,29.6320034 C7.87628986,29.7893322 7.62074359,29.7893322 7.46274684,29.6320034 L0.368522185,22.5659038 C0.210492605,22.408575 0.210492605,22.1541947 0.368522185,21.9968659 L0.607224668,21.7592219 C0.765254248,21.6018931 1.02076769,21.6018931 1.17879727,21.7592219 L7.1803096,27.7341206 L7.1803096,0.651673859 C7.1803096,0.430766312 7.36188109,0.25 7.58377261,0.25 L7.91999179,0.25 C8.14188331,0.25 8.3234548,0.430766312 8.3234548,0.651673859 L8.3234548,27.7341206 L14.3216181,21.7592219 C14.4796148,21.6018931 14.7351611,21.6018931 14.8931907,21.7592219 L15.1318932,21.9968659 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#40B3DB",
    transform: "rotate(-90 8.25 7.75)",
    xlinkHref: "#down-arrow-a"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorArrow);
export default __webpack_public_path__ + "static/media/connector-arrow.0f07903c.svg";
export { ForwardRef as ReactComponent };